import {POObject} from './POObject';

export class POSite extends POObject {
  static type = 'Site';
  type = POSite.type;
}
